import React, { useState } from "react";
import { Modal } from "react-bootstrap";

const UploadFilesModal = ({ setAttachments, onHide, ...props }) => {
  const [files, setFiles] = useState([]);

  // Extract file extension in uppercase
  const getFileExtension = (file) => {
    const parts = file.name.split(".");
    return parts.length > 1 ? parts.pop().toUpperCase() : "UNKNOWN";
  };

  // Handle file selection
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const allowedTypes = [
      "application/pdf",
      "text/plain",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];

    const validFiles = selectedFiles.filter((file) =>
      allowedTypes.includes(file.type)
    );

    setFiles((prev) => {
      const existingNames = prev.map((f) => f.name);
      const newUniqueFiles = validFiles.filter(
        (f) => !existingNames.includes(f.name)
      );
      return [...prev, ...newUniqueFiles];
    });
  };

  // Handle delete
  const handleDelete = (index) => {
    const newFiles = [...files];
    newFiles.splice(index, 1);
    setFiles(newFiles);
  };

  //uploading attachments
  const uploadAttachments = () => {
    setAttachments((attachments) => [...attachments, ...files]);
    setFiles([]);
    closeModel();
  }

  const closeModel = () => {
    onHide();
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="upload-file-modal"
    >
      <div className="p-4">
        <div className="d-flex justify-content-between align-items-center border-bottom pb-3">
          <h4 className="font-14 font-weight-bold heading-color mb-0">
            Upload Files
          </h4>
          <button className="bg-transparent border-0" onClick={closeModel}>
            <img src="/assets/images/cross-icon.svg" alt="Close" />
          </button>
        </div>

        {/* File Upload Trigger */}
        <div className="w-100 pt-2">
          <label htmlFor="myfile" className="file-upload-wrapper">
            <img src="/assets/images/upload-icon.svg" alt="Upload" />
            <p className="font-13 font-weight-medium text-color">
              Drag & drop or{" "}
              <span className="font-13 font-weight-medium text-decoration-underline text-success">
                browse
              </span>
            </p>
          </label>
          <input
            type="file"
            id="myfile"
            name="myfile"
            multiple
            onChange={handleFileChange}
            accept="application/pdf, text/plain, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            style={{ display: "none" }}
          />
        </div>

        {/* Display Selected Files */}
        <div className="py-2">
          {files.map((file, index) => (
            <div className="upload-file-card mb-2" key={index}>
              <div className="upload-file-info d-flex justify-content-between align-items-center">
                <div className="d-flex gap-3 align-items-center">
                  <img
                    src="/assets/images/file-icon.svg"
                    className="file-icon"
                    alt="File"
                    style={{
                      width: "30px",
                      height: "30px",
                      objectFit: "contain",
                    }}
                  />
                  <div className="file-name">
                    <h6>{file.name}</h6>
                    <p>{getFileExtension(file)}</p>
                  </div>
                </div>
                <button
                  className="border-0 bg-transparent"
                  onClick={() => handleDelete(index)}
                >
                  <img src="/assets/images/delete-icon.svg" alt="Delete" />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Action Buttons */}
        <div className="d-flex justify-content-center gap-4">
          <button className="n-u-btn" onClick={() => uploadAttachments()}>
            Upload
          </button>
          <button className="c-b-btn" onClick={closeModel}>
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default UploadFilesModal;
